// src/pages/Products.js
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./Products.css";
import HeaderThree from "./HeaderThree";
import FooterOne from "../footer/FooterOne";

const Products = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [categoryName, setCategoryName] = useState("All Products");

  const [selectedProduct, setSelectedProduct] = useState(null);

  const pageSize = 12;

  const [categoryCache, setCategoryCache] = useState({});

  useEffect(() => {
    if (Object.keys(categoryCache).length === 0) {
      fetchAllCategories();
    } else {
      updateCategoryName();
    }
  }, [categoryId, categoryCache]);

  useEffect(() => {
    fetchProducts();
  }, [page, categoryId]);

  const fetchAllCategories = async () => {
    try {
      const res = await axios.get(
        "https://nazarenterprise.com/nazar-admin/api/get_products_category.php"
      );

      const map = {};
      const buildMap = (cats) => {
        cats.forEach((cat) => {
          map[cat.id] = cat.category_name;
          if (cat.sub_categories) buildMap(cat.sub_categories);
        });
      };

      buildMap(res.data.data || []);
      setCategoryCache(map);
      updateCategoryName(map);
    } catch (err) {
      console.error("Category error:", err);
    }
  };

  const updateCategoryName = (cache = categoryCache) => {
    if (categoryId && cache[categoryId]) {
      setCategoryName(cache[categoryId]);
    } else {
      setCategoryName("All Products");
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        "https://nazarenterprise.com/nazar-admin/api/get_products.php",
        {
          params: {
            category_id: categoryId || 0,
            page,
            page_size: pageSize,
          },
        }
      );

      setProducts(res.data.data || []);
      setTotalPages(res.data.total_pages || 1);
    } catch (err) {
      console.error("Product fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const openModal = (product) => {
    setSelectedProduct(product);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedProduct(null);
    document.body.style.overflow = "unset";
  };

  const createMarkup = (html) => {
    return { __html: html || "" };
  };

  if (loading) {
    return (
      <div className="products-loading" style={{textAlign: "center", marginTop:"80px"}}>
        <div className="spinner"></div>
        <p>Loading premium marine products...</p>
      </div>
    );
  }

  return (
    <>
      <HeaderThree />
      <div className="products-page">
        <div className="products-header">
          <h1>{categoryName}</h1>
          <p>Explore high-quality ship machinery & marine equipment</p>
          <div className="header-underline"></div>
        </div>

        <div className="products-grid">
          {products.length > 0 ? (
            products.map((product) => {
              const imgUrl =
                product.image && product.image.trim() !== ""
                  ? product.image
                  : null;

              return (
                <div key={product.id} className="product-card">
                  <div className="product-image-wrapper">
                    {imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={product.title}
                        className="product-image"
                      />
                    ) : (
                      <div className="product-placeholder">
                        <span>No Image</span>
                      </div>
                    )}

                    <div className="product-overlay">
                      <h3>{product.title}</h3>
                      <p
                        className="view-details-btn"
                        onClick={() => openModal(product)}
                      >
                        View Details
                      </p>
                    </div>
                  </div>

                  <div className="product-info">
                    <h4>{product.title}</h4>

                    <div
                      className="product-desc"
                      dangerouslySetInnerHTML={createMarkup(
                        product.des.substring(0, 120) + "..."
                      )}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-products">
              <p>No products found in this category.</p>
              <Link to="/categories" className="back-link">
                Back to Categories
              </Link>
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
              className="page-btn"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => handlePageChange(i + 1)}
                className={`page-btn ${page === i + 1 ? "active" : ""}`}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPages}
              className="page-btn"
            >
              Next
            </button>
          </div>
        )}

        <div className="products-footer">
          <Link to="/contact" className="cta-button">
            Need Custom Solution?
          </Link>
        </div>
      </div>

      {/* PRODUCT MODAL */}
      {selectedProduct && (
        <div
          className="product-modal-overlay"
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className="product-modal">
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>

            <div className="modal-content-grid">
              <div className="modal-image-wrapper">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.title}
                  className="modal-product-image"
                />
              </div>

              <div className="modal-details">
                <h2 className="modal-product-title">
                  {selectedProduct.title}
                </h2>

                <div
                  className="modal-product-desc"
                  dangerouslySetInnerHTML={{ __html: selectedProduct.des }}
                />

                <a href="/contact" className="contact-us-btn">
                  Contact Us for Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <FooterOne />
    </>
  );
};

export default Products;
